import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/RuleDefinition.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/rules`;
	}
	list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, e));
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	create(e) {
		return this.api.post(`${n.baseUrl}`, e);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	copy(e) {
		return this.api.post(`${n.baseUrl}/copy`, e);
	}
	validateCopyRulesToTrackingId(e) {
		return this.api.post(`${n.baseUrl}/copy/validate`, e);
	}
};
export { n as RuleDefinition };

//# sourceMappingURL=RuleDefinition.js.map